export default "__VITE_ASSET__Cliqwnrd__"